export abstract class LoadingDefaults {
  static readonly StartIndicatorTimeout = 250;
}
